'use strict'

function defaultValueRuleCount (component) {

  const rules = component && component.defaultValueRules && component.defaultValueRules.rules

  if (!Array.isArray(rules)) return 0

  return rules.length
}

function defaultValueRuleBadge (component) {

  const count = defaultValueRuleCount(component)

  if (!count) return null

  const label = count === 1 ? 'default rule' : `${count} default rules`

  const title = count === 1
    ? 'This form has a default value rule'
    : `This form has ${count} default value rules`

  return { label, title }
}

module.exports = { defaultValueRuleCount, defaultValueRuleBadge }
